const COOKIE_NAME_GY_TOKEN_KEY = "gy_portal_token";

// COMMON
export function setCookie(name, value, options = {}) {
    //console.info('CookieService SET', name, value, options);
    options = {
        path: '/',
        ...options
    };
  
    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }
  
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
  
    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }
  
    document.cookie = updatedCookie;
}

export function getCookie(name) {
    //console.info('CookieService GET', name);
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function deleteCookie(name) {
    //console.info('CookieService DELETE', name);
    setCookie(name, "", {
        'max-age': -1
    })
}

// GY TOKEN
export const setGyTokenCookie = (value, options) => setCookie(COOKIE_NAME_GY_TOKEN_KEY, value, options);
export const getGyTokenCookie = () => getCookie(COOKIE_NAME_GY_TOKEN_KEY);
export const deleteGyTokenCookie = () => deleteCookie(COOKIE_NAME_GY_TOKEN_KEY);

export default {
    setCookie, getCookie, deleteCookie,
    setGyTokenCookie, getGyTokenCookie, deleteGyTokenCookie,
};
